import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import PerformanceGridLayout from 'screens/performanceReview/manageAndInsights/components/PerformanceGridLayout';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { useExpandableContainer } from 'uiToolkitV1/ExpandableContainerProvider';
import { TextHeader3 } from 'uiToolkitV1/Typography';

import PreviewPerformanceLineChart from '../PreviewPerformanceLineChart/PreviewPerformanceLineChart';

const PreviewPerformanceGrid = ({
  boxHeight = '72',
  lineChartData,
  gridData,
  rows,
  columns,
  hideYAxisLabelTicks = false,
}) => {
  const { isExpanded = false } = useExpandableContainer();
  const { moduleName } = useOrganisationSettings();

  const linesInfo = [
    {
      key: 'numOverallRating',
      name: 'Rating',
      color: '#4657AE',
    },
  ];

  const xAxisTickFormatter = (x) => (x ? `${x.slice(0, 15)}...` : x);
  const yAxisTickFormatter = (value) =>
    Number.isNaN(lineChartData.ratingMap[value])
      ? lineChartData.ratingMap[value]
      : Number(lineChartData.ratingMap[value]);

  return (
    <Flex direction="column">
      <TextHeader3 bold m="15px 25px" color="text.g1">
        {modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)} vs Competency
      </TextHeader3>
      <Box flexGrow={1} position="relative" height={isExpanded ? '545px' : '335px'}>
        <PreviewPerformanceLineChart
          data={isExpanded ? lineChartData.expandedViewRatingDetails : lineChartData.reviewRatingDetailsResponseList}
          height={rows * boxHeight + 100}
          yAxisLabel="Potential →"
          xAxisLabel={hideYAxisLabelTicks ? 'Overall →' : 'Performance →'}
          xAxisKey="reviewCycle"
          yAxisKey="numOverallRating"
          linesInfo={linesInfo}
          metaDataKey="ratingSplit"
          metaDataLabelMap={lineChartData.dataMap}
          xAxisType="category"
          yAxisType="number"
          xAxisTickFormatter={(x) => xAxisTickFormatter(x)}
          yAxisTickFormatter={(value) => yAxisTickFormatter(value)}
          hideYAxisLabelTicks={hideYAxisLabelTicks}
        />
        <PerformanceGridLayout
          rows={rows}
          columns={columns}
          boxHeight={isExpanded ? boxHeight / rows + 432.5 / rows : boxHeight / rows + 166.5 / rows}
          spacing="1px"
          boxData={gridData.flat()}
          employeeDetails={gridData.flat()}
          position="absolute"
          margin={isExpanded ? '25px 90px' : '27px 70px'}
          width="calc(100% - 140px)"
          top={isExpanded ? 0 : -1}
          left={isExpanded ? 0 : '20px'}
        />
      </Box>
    </Flex>
  );
};

export default PreviewPerformanceGrid;
